import axios from 'axios';

// all backend apis calls
// backend apis are the HTTP cloud functions

const actions = {
    validateCodeApi: async (_, code) => {
        
        try {
            const url = `${process.env.VUE_APP_CLOUD_FUNCTIONS_URL}/validate-code/${code}`
            console.log("backend api")
            console.log(url)
            let response = await axios.post(
                url
            )
            console.log(response.data)
            return response.data["is_valid"]
            
        } catch (error) {
          console.error("Error validating code:", error);
          throw error; // Re-throw the error if needed
        }
    }
}

export default actions